export const highlight = (value: string, searchPhrase?: string) =>
  searchPhrase ? value.replace(new RegExp(searchPhrase, 'gi'), '<mark>$&</mark>') : value;
